import React from "react";
import { ArrowDownLeft, ArrowUpRight, Plus, Wallet } from "lucide-react";
import { fmtDate } from "../AdminUi";

const KIND = { topup: "You topped up", sale: "Customer bought", transfer: "Sent from panel", manual_payment: "Direct payment" };
const n = (v) => Number(v || 0).toLocaleString("en-IN");

export const PanelBalance = ({ p, onTopup }) => (
  <section className="rounded-3xl border border-sky-200 bg-gradient-to-br from-sky-50 to-white p-5 sm:p-6 space-y-4" data-testid="panel-balance">
    <div className="flex flex-wrap items-start justify-between gap-4">
      <div>
        <p className="text-xs uppercase tracking-[0.2em] font-mono text-sky-700 flex items-center gap-1.5"><Wallet size={13} /> Your panel balance</p>
        <p className={`mt-2 text-5xl font-bold font-mono ${p.balance < 0 ? "text-rose-600" : "text-slate-900"}`} data-testid="panel-balance-value">{n(p.balance)}</p>
        <p className="text-sm text-slate-500 mt-1">credits · {n(p.topped_up)} topped up · {n(p.handed_out)} given to users</p>
      </div>
      <button onClick={onTopup} data-testid="panel-topup-btn" className="h-11 px-5 rounded-full bg-slate-900 text-white text-sm font-semibold flex items-center gap-2 hover:bg-slate-700 transition-colors">
        <Plus size={15} /> Top up panel
      </button>
    </div>
    <p className="text-xs text-slate-500">When a customer recharges on your website, or you add credit to someone, those credits are taken from here.</p>
    {p.ledger.length > 0 && (
      <ul className="divide-y divide-slate-100 rounded-2xl border border-slate-200 bg-white" data-testid="panel-ledger">
        {p.ledger.slice(0, 8).map((e) => (
          <li key={e.id} className="flex items-center gap-3 px-4 py-2.5 text-sm" data-testid={`panel-ledger-row-${e.id}`}>
            {e.delta > 0 ? <ArrowDownLeft size={15} className="text-emerald-600 shrink-0" /> : <ArrowUpRight size={15} className="text-slate-400 shrink-0" />}
            <span className="min-w-0 flex-1 truncate text-slate-700">{KIND[e.kind] || e.kind}{e.user_email && e.delta < 0 ? ` · ${e.user_email}` : ""}</span>
            <span className={`font-mono ${e.delta > 0 ? "text-emerald-700" : "text-slate-600"}`}>{e.delta > 0 ? "+" : ""}{n(e.delta)}</span>
            <span className="hidden sm:block text-xs text-slate-400 w-36 text-right">{fmtDate(e.created_at)}</span>
          </li>
        ))}
      </ul>
    )}
  </section>
);

export default PanelBalance;
